<template>
    <hm-content title="">
        <div class="table-panel flex flex-end">
            <div>
                <el-select v-model="searchCondition.settleState" filterable placeholder="请选择核验状态" size="small" clearable class="mr10" @change="search">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-date-picker
                        size="small"
                        v-model="searchCondition.dateValue"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        class="mr10"
                        @change="search"
                >
                </el-date-picker>
            </div>
          <el-button
              type="success"
              size="small"
              @click="output"
              :loading="isOutputing"
          >对账单导出</el-button
          >
        </div>
        <div  class="inputDeep">
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        type="index"
                        label="序号"
                        width="50"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="settleDate"
                        label="结存日期"
                        >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="收入（元）">
                    <template slot-scope="scope">
                        <span style="color: #2fc348">+{{scope.row.inAmount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="inNum"
                        label="收入笔数">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        label="支出（元）">
                    <template slot-scope="scope">
                        <span style="color: red">-{{scope.row.outAmount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="outNum"
                        label="支出笔数">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="totalAmount"
                        label="日结算金额">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="settleState"
                        label="核验状态"
                >
                    <template slot-scope="scope">
                        {{ scope.row.settleState == "wait" ? "待核验" : "已核验"  }}
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="remark"
                        label="备注">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.remark"  placeholder="双击输入备注" size="small" @blur="editRemark(scope)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="id"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button
                                size="small"
                                type="text"
                                @click="settleStateChange(scope)"
                        >核验</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="hm-pagination">
        <el-pagination
                background
                :total="total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
        ></el-pagination>
    </div>
    </hm-content>
</template>

<script>
export default {
    name: "storeFinanceDayStatInfo",
    data() {
        return {
            total: 0,
            options: [{
                value: 'insanity',
                label: '已核验'
            }, {
                value: 'wait',
                label: '待核验'
            }],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
            searchCondition: {
                settleState: '',
                dateValue: ""
            },
            tableData: [{
                id: "",
                settleDate:"",
                inAmount: "",
                inNum:"",
                outAmount: "",
                outNum: "",
                dayClearing: "",
                settleState: "",
                remark: ""
            }],
            currentPage: 1,
            pageSize: 10,
            isOutputing: false
        }
    },
    created() {
        this.queryList();
    },
    methods: {
        paging(page) {
            this.currentPage = page;
            this.queryList();
        },
        handleSizeChange(size) {
            this.currentPage = 1;
            this.pageSize = size;
            this.queryList();
        },
        search() {
            this.currentPage = 1;
            this.queryList();
        },
        isArray(arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        async queryList(){
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
            if (this.isArray(searchCondition.dateValue)) {
                searchCondition.queryStartDate =
                    searchCondition.dateValue && searchCondition.dateValue.length > 0 ? searchCondition.dateValue[0] + " 00:00:00" : "";
                searchCondition.queryEndDate =
                    searchCondition.dateValue && searchCondition.dateValue.length > 0 ? searchCondition.dateValue[1] + " 23:59:59" : "";
            }
            Object.assign(params, searchCondition);
            const { result } = await this.$store.dispatch("queryPageList", params);
            const { records, total } = result;
            this.tableData = records;
            this.total = total;
        },
        async settleStateChange(scope){  //修改审核状态
            let params = JSON.parse(JSON.stringify(scope.row));
            params.settleState = "insanity";
            await this.$store.dispatch("editStoreSettleState", params);
            this.queryList();
        },
        async editRemark(scope){
            let params = JSON.parse(JSON.stringify(scope.row));
            params.remark = scope.row.remark;
            let params1 = {
                id: params.id,
                remark: params.remark
            }
            await this.$store.dispatch("editStoreSettleState", params1);
            this.queryList();
        },
        async output() {
          const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
          if (this.isArray(searchCondition.dateValue)) {
            searchCondition.startDate =
                searchCondition.dateValue && searchCondition.dateValue.length > 0 ? searchCondition.dateValue[0] + " 00:00:00" : "";
            searchCondition.endDate =
                searchCondition.dateValue && searchCondition.dateValue.length > 0 ? searchCondition.dateValue[1] + " 23:59:59" : "";
          }
          if (
              Date.parse(searchCondition.endDate) - Date.parse(searchCondition.startDate) >
              31 * 24 * 60 * 60 * 1000 ||
              Date.parse(searchCondition.startDate) > Date.parse(searchCondition.endDate)
          ) {
            this.$message({
              message: "导出时间范围不能超过1个月",
              type: "warning"
            });
            return;
          }

          searchCondition.exportName = "支付对账单";
          this.$store.dispatch("export", searchCondition);
          setTimeout(() => {
            this.$message({
              message: "已加入导出队列正在生成报表，请在导出列队中查看！",
              type: "success"
            });
            this.hidden = false;
            this.drawer = false;
        }, 0);
      },
    }
}
</script>

<style scoped>
.inputDeep>>>.el-input__inner{
    border: 0;
    background: none;
}
</style>
